import axios from 'axios';
import type { AccountId } from '@hotjar/account';
import type { OrganizationId } from '@hotjar/organization';

const PATH_PREFIX = `/api/v1/accounts`;

const getUserLookupEmailPath = (accountId: AccountId, organizationId: OrganizationId): string => {
  return `${PATH_PREFIX}/${accountId}/organizations/${organizationId}/user-lookup/recipient-email`;
};

export interface GetRecipientEmailRequest {
  accountId: AccountId;
  organizationId: OrganizationId;
}

export async function getRecipientEmail(request: GetRecipientEmailRequest): Promise<string> {
  const path = getUserLookupEmailPath(request.accountId, request.organizationId);
  const response = await axios.get(path);

  if (response.data === undefined) {
    throw new Error('Error retrieving user-lookup recipient-email');
  }

  return response.data.email;
}

export interface CreateUpdateRecipientEmailRequest {
  accountId: AccountId;
  organizationId: OrganizationId;
  recipientEmail: string;
}

export async function createRecipientEmail(
  request: CreateUpdateRecipientEmailRequest,
): Promise<string> {
  const path = getUserLookupEmailPath(request.accountId, request.organizationId);

  const response = await axios.post(path, { email: request.recipientEmail });

  if (response.data === undefined || response.data.success !== true) {
    throw new Error('Error creating user-lookup recipient-email');
  }

  return response.data.email;
}

export async function updateRecipientEmail(
  request: CreateUpdateRecipientEmailRequest,
): Promise<string> {
  const path = getUserLookupEmailPath(request.accountId, request.organizationId);

  const response = await axios.put(path, { email: request.recipientEmail });

  if (response.data === undefined || response.data.success !== true) {
    throw new Error('Error updating user-lookup recipient-email');
  }

  return response.data.email;
}

export interface DeleteRecipientEmailRequest {
  accountId: AccountId;
  organizationId: OrganizationId;
}

export async function deleteRecipientEmail(request: DeleteRecipientEmailRequest): Promise<void> {
  const path = getUserLookupEmailPath(request.accountId, request.organizationId);

  const response = await axios.delete(path);

  if (response.data === undefined || response.data.success !== true) {
    throw new Error('Error deleting user-lookup recipient-email');
  }
}
